<template>
  <div class="banxin fu">
    <img
      src="../../assets/img/home/16.png"
      style="width: 130px;vertical-align: bottom;height: 30px;margin-top:10px"
    />
    <div
      class="xiaozi"
      @click="tiaozhuan('/')"
      :style="danqian=='/'?'color: #409eff;':''"
    >关于鸿闻</div>
    <div
      class="xiaozi"
      @click="tiaozhuan('/hyyy')"
      :style="danqian=='/hyyy'?'color: #409eff;':''"
    >行业应用</div>
    <div
      class="xiaozi"
      @click="tiaozhuan('/lxwm')"
      :style="danqian=='/lxwm'?'color: #409eff;':''"
    >联系我们</div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      danqian: ''
    }
  },
  created () {
    this.danqian = this.$route.path
  },
  methods: {
    tiaozhuan (val) {
      if (val != this.danqian) {
        this.danqian = val
        this.$router.push(val)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.fu {
  display: flex;
  .xiaozi {
    cursor: pointer;
    font-size: 16px;
    margin: 15px 0 0 40px;
    &:hover {
      color: #409eff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/HeadNav.vue